import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74439418"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "li-inner" }
const _hoisted_2 = {
  key: 0,
  class: "unpinned"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Unpinned", -1))
const _hoisted_4 = { class: "expand" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "expand_more", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "ref" }
const _hoisted_8 = { class: "main" }
const _hoisted_9 = { class: "description" }
const _hoisted_10 = {
  key: 1,
  class: "counter"
}
const _hoisted_11 = { class: "app-badge-wrapper" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "alternate_email", -1))
const _hoisted_13 = { class: "app-priority-standard-bg app-badge" }
const _hoisted_14 = {
  key: 2,
  class: "counter"
}
const _hoisted_15 = { class: "app-badge-wrapper" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "list_alt", -1))
const _hoisted_17 = { class: "app-priority-standard-bg app-badge" }
const _hoisted_18 = {
  key: 3,
  class: "no-tasks"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "task_alt", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 4,
  class: "counter"
}
const _hoisted_22 = { class: "app-badge-wrapper" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "report", -1))
const _hoisted_24 = { class: "app-priority-urgent-bg app-badge" }
const _hoisted_25 = {
  key: 5,
  class: "no-tasks"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "task_alt", -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "counter" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconCheckbox = _resolveComponent("IconCheckbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_ctx.removing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("a", {
              href: "#",
              class: "action",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.togglePin(_ctx.center.dbid, true)), ["prevent"]))
            }, "Undo")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.showMore(_ctx.center.dbid)), ["prevent"]))
        }, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_7, " #" + _toDisplayString(_ctx.center.refid), 1),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", null, _toDisplayString(_ctx.center.title), 1),
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.center.description), 1)
      ]),
      (_ctx.related.mentions > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.related.mentions), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.related.standard > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.related.standard), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20)),
      (_ctx.related.urgent > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.related.urgent), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27)),
      _createElementVNode("div", _hoisted_28, [
        _createVNode(_component_IconCheckbox, {
          color: "#3d9209",
          size: 30,
          modelValue: _ctx.pinned,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.togglePin(_ctx.center.dbid, $event))),
          title: "Cost Center Pinned",
          icon: "push_pin"
        }, null, 8, ["modelValue"])
      ])
    ])
  ]))
}